import { Component, Input, OnInit, OnDestroy, ViewChild, AfterViewInit, ContentChild } from '@angular/core';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ProjectTimelineActivityComponent } from '../project-timeline-activity/project-timeline-activity.component';

@Component({
    selector: 'app-milestone-phase-card',
    templateUrl: './milestone-phase-card.component.html',
    styleUrls: ['./milestone-phase-card.component.scss'],
    standalone: false
})
export class MilestonePhaseCardComponent implements OnInit, OnDestroy, AfterViewInit {
  @Input() moduleId: number = 0;
  @Input() recordId: number | null = null;
  @Input() showIcon: boolean = true;
  @Input() labelText: string = 'Milestone Phase';

  // ContentChild to find ProjectTimelineActivityComponent in parent's content
  @ContentChild(ProjectTimelineActivityComponent) projectTimelineActivityComponent?: ProjectTimelineActivityComponent;

  // Nearest milestone info pulled via subscription
  nearestMilestonePhase: {
    name: string;
    status: string;
    progress: number;
    additionalCount?: number;
    additionalMilestones?: Array<{
      id: number;
      name: string;
      status: string;
      progress: number;
      due_date?: string;
      task_count?: number;
      completed_task_count?: number;
    }>
  } | null = null;

  // Tooltip visibility flag
  showMilestoneTooltip: boolean = false;

  private destroy$ = new Subject<void>();
  private milestoneSubscription: any;

  constructor() { }

  ngOnInit(): void {
    // Component initialized
  }

  ngAfterViewInit(): void {
    // Subscribe to milestone updates after view init
    setTimeout(() => this.subscribeToMilestoneUpdates(), 100);
  }

  /**
   * Subscribe to milestone updates from ProjectTimelineActivityComponent
   */
  private subscribeToMilestoneUpdates(): void {
    if (this.projectTimelineActivityComponent) {
      this.milestoneSubscription = this.projectTimelineActivityComponent.nearestMilestone$
        .pipe(takeUntil(this.destroy$))
        .subscribe((milestone: any) => {
          // Handle null milestone (no in_progress milestones found)
          if (!milestone) {
            this.nearestMilestonePhase = null;
            return;
          }

          // The milestone should already have progress calculated
          const progressValue = typeof milestone.progress === 'number' ? milestone.progress : 0;

          this.nearestMilestonePhase = {
            name: milestone.name || milestone.milestone_name || '',
            status: milestone.status || 'in_progress',
            progress: progressValue,
            additionalCount: milestone.additionalCount || 0,
            additionalMilestones: milestone.additionalMilestones || []
          };
        });
    }
  }

  /**
   * Format status for display (converts underscore to space and capitalizes)
   */
  formatStatus(status: string | undefined): string {
    if (!status) return '--';

    // Replace underscores with spaces and convert to proper case
    return status
      .replace(/_/g, ' ')
      .replace(/\b\w/g, (char) => char.toUpperCase());
  }

  ngOnDestroy(): void {
    // Clean up subscriptions
    if (this.milestoneSubscription) {
      this.milestoneSubscription.unsubscribe();
    }
    this.destroy$.next();
    this.destroy$.complete();
  }
}